import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ITagsProps extends IBaseElementProps {
	/**
	 * Tags
	 */
	tags?: ILink[];
}

/**
 * Tags
 * @block
 * @requiresHooks
 * @icon tag
 */
const Tags: React.FC<ITagsProps> = ({ className, tags = [] }) => (
	<ul className={className || cn('tags', className)}>
		{tags.length > 0 &&
			tags.map((link, index) => (
				<li key={index} className="tags__item">
					<Button className="tags__link" {...link} />
				</li>
			))}
	</ul>
);

export default Tags;
